<template>
    <div class="card">
        <div class="card-image">
            <figure class="image is-4by3">
                <img :src="user.avatar_url" alt="Image">
            </figure>
        </div>
        <div class="card-content">
            <div class="media">
                <div class="media-content">
                    <p class="title is-4">{{ user.full_name }}</p>
                    <p class="subtitle is-6">{{ user.email }}</p>
                </div>
            </div>

            <div class="content">
                {{ user.about }}
                <small>Role: <strong>{{ user.role }}</strong></small>
                <br>
                <small v-if="user.mobile">Mobile: <strong>{{ user.mobile }}</strong></small>
                <br>
                <small v-if="user.phone_extension">Phone Extension: <strong>{{ user.phone_extension }}</strong></small>
                <br>
                <small>Member since: <strong>{{ user.created_at | date }}</strong></small>
                <br>
                <small>Hourly rate: <strong>{{ user.hourly_rate | currency }}</strong></small>
                <img v-if="user.signature" :src="user.signature" class="signature">
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: ['userId'],

        computed: {
            ...mapGetters(['userById']),

            user() {
                return this.userById(this.userId)
            }
        }
    }
</script>
